import { Badge, IconButton, IconButtonProps } from '@mui/material';

import { ListFilter } from '@/shared/components/icons';

interface FilterProps extends IconButtonProps {
  isActive: boolean;
}

const FilterButton = ({ isActive, ...others }: FilterProps) => {
  return (
    <IconButton
      size='small'
      color={isActive ? 'primary' : 'default'}
      data-active={isActive}
      {...others}
    >
      <Badge variant='dot' color='primary' invisible={!isActive}>
        <ListFilter fontSize='inherit' />
      </Badge>
    </IconButton>
  );
};

export default FilterButton;
